import React from 'react';
import classes from './PersonalHero.module.css';
import BtnComponent from '../../ui/buttons/BtnComponent';

const PersonalHero = ({ leftImage, leftText, button }) => {
  return (
    <div className={classes.personalHero}>
      <div className={classes.leftSection}>
        {leftImage &&
          <div className={classes.imageContainer}>
            {leftImage.kind === 'monster' &&
              <div className={classes.monsterImage}>
                {/* כאן יוצג תמונת המפלצת */}
                🐉
              </div>
            }
            {leftImage.kind === 'school' &&
              <div className={classes.schoolImage}>
                {leftImage.url ?
                  <img src={leftImage.url} alt="בית ספר" />
                  :
                  <div className={classes.schoolPlaceholder}>🏫</div>
                }
              </div>
            }
          </div>
        }
        <p className={classes.leftText}>{leftText}</p>
      </div>
      {button &&
        <div className={classes.buttonContainer}>
          <BtnComponent
            type={button.type}
            text={button.text}
            className={classes.actionButton}
          />
        </div>
      }
    </div>
  );
};

export default PersonalHero;

